// Which website brand a lead came from. One tenant can run several sites (e.g. Stop
// Pest + Solveary); the site posts intake_attributes.site_brand and the office needs
// to see it on the card. Unknown slugs are title-cased, never dropped.
const BRAND_LABELS = {
  'stop-pest': 'Stop Pest',
  solveary: 'Solveary',
};

export function siteBrandLabel(lead) {
  const raw = String(lead?.intake_attributes?.site_brand || lead?.site_brand || '').trim();
  if (!raw) return '';
  const known = BRAND_LABELS[raw.toLowerCase()];
  if (known) return known;
  return raw
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}
